import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreenLaptopComponent } from './screen-laptop/screen-laptop.component';
import { ScreenIphoneComponent } from './screen-iphone/screen-iphone.component';
import { ScreenIpadComponent } from './screen-ipad/screen-ipad.component';
import { SelectPhotoPositionComponent } from './select-photo-position/select-photo-position.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ButtonModule } from '../button/button/button.module';
import { SettingCoverComponent } from './setting-cover/setting-cover.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PhotoSelectionComponent } from './photo-selection/photo-selection.component';
import { PortalModule } from '@angular/cdk/portal';
import { SideDialogModule } from '../side-dialog';
import { ZalamoDialogModule } from '../zalamo-dialog/zalamo-dialog.module';
import { CoverEditorViewComponent } from './cover-view/cover-editor-view.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ImageManagementModule } from '../image-management/image-management.module';
import { FormsModule } from '@angular/forms';
import { CoverDrawerComponent } from './cover-drawer/cover-drawer.component';
import { CoverDisplayStandaloneModule } from 'ZalamoLibrary/src/lib/ui/cover/cover/cover-display-standalone/cover-display-standalone.module';
import { MatMenuModule } from "@angular/material/menu";
import {TranslatePipe} from "@ui/nls/translations/translate.pipe";
import {TranslationsModule} from "@ui/nls/translations/translations.module";
import { ScreenSquareComponent } from './screen-square/screen-square.component';

@NgModule({
  declarations: [
    ScreenLaptopComponent,
    ScreenIpadComponent,
    ScreenIphoneComponent,
    SelectPhotoPositionComponent,
    SettingCoverComponent,
    PhotoSelectionComponent,
    CoverEditorViewComponent,
    CoverDrawerComponent,
    ScreenSquareComponent,
  ],
  exports: [
    ScreenLaptopComponent,
    ScreenIpadComponent,
    ScreenIphoneComponent,
    SelectPhotoPositionComponent,
    SettingCoverComponent,
    PhotoSelectionComponent,
    CoverEditorViewComponent,
    CoverDrawerComponent,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    ButtonModule,
    MatButtonModule,
    MatIconModule,
    PortalModule,
    SideDialogModule,
    ZalamoDialogModule,
    MatProgressBarModule,
    ImageManagementModule,
    FormsModule,
    CoverDisplayStandaloneModule,
    MatMenuModule,
    TranslationsModule,
  ],
})
export class CoverModule {}
